import React from 'react';
import { colors } from '../_utils';
var List = function (props) {
    var items = props.items, flush = props.flush, small = props.small, _a = props.selected, selected = _a === void 0 ? [] : _a, className = props.className, onSelected = props.onSelected;
    var ulClasses = ['list-group'];
    if (flush)
        ulClasses.push('list-group-flush');
    if (className)
        ulClasses.push(className);
    var liClasses = [
        'list-group-item',
        'd-flex',
        'justify-content-between',
        'align-items-center'
    ];
    if (small)
        liClasses.push('py-2');
    return (React.createElement("ul", { className: ulClasses.join(' ') }, items === null || items === void 0 ? void 0 : items.map(function (item) { return (React.createElement("li", { key: item.id, className: liClasses.join(' '), style: {
            cursor: !!onSelected ? 'pointer' : 'auto',
            backgroundColor: (selected === null || selected === void 0 ? void 0 : selected.includes("" + (item === null || item === void 0 ? void 0 : item.id)))
                ? colors.cyan
                : 'inherit'
        }, onClick: function (nativeEvent) { return onSelected === null || onSelected === void 0 ? void 0 : onSelected(item, nativeEvent); } }, item === null || item === void 0 ? void 0 :
        item.content,
        (item === null || item === void 0 ? void 0 : item.badgeCount) !== undefined && (React.createElement("span", { className: "badge badge-secondary badge-pill" }, item.badgeCount)))); })));
};
export default React.memo(List);
